export default __webpack_public_path__ + "static/media/logo_termo.0a183fa7.jpg";